import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    systemNumbers: {
      title: 'Numery systemowe',
      type: 'object',
      properties: {
        mdok: {
          title: 'Numer dokumentu MDOK UM',
          type: 'string'
        },
        mdokId: {
          title: 'UID dokumentu MDOK UM',
          type: 'string'
        },
        sign: {
          title: 'Znak sprawy MDOK UM',
          type: 'string'
        },
        caseId: {
          title: 'UID sprawy MDOK UM',
          type: 'string'
        },
        mdokJo: {
          title: 'Numer dokumentu MDOK JO',
          type: 'string'
        },
        mdokJoId: {
          title: 'UID dokumentu MDOK JO',
          type: 'string'
        },
        signJo: {
          title: 'Znak sprawy MDOK JO',
          type: 'string'
        },
        caseJoId: {
          title: 'UID sprawy MDOK JO',
          type: 'string'
        }
      }
    },
    comment: {
      title: 'Treść',
      type: 'string'
    }
  },
  allOf: [validationMessages]
};
